import moment from "moment";

export default {
  methods: {
    formatFromNow(ts) {
      if (!ts) {
        return "-";
      }
      return moment(ts).fromNow();
    },
    formatDatetime(ts) {
      if (!ts) {
        return "-";
      }
      return moment(ts).format("LLL");
    }
  }
};
